import React from 'react';
import { Modal } from 'antd';
import Button from '../../common/Button/Button';

const OrderFailedModal = props => {
  const { visible, onCancel } = props;
  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      footer={null}
      centered={true}
      title="Order Failed"
      wrapClassName="order-failed-modal"
      getContainer={false}
    >
      <div className="order-failed-modal--content">
        <div className="order-failed-modal--oops">PAYMENT FAILED!</div>
        <div className="order-failed-modal--title">
          Uh-Oh! Your order couldn’t be processed at this time.
        </div>
        <div className="order-failed-modal--details">
          Don’t worry.
          <br />
          Any amount deducted will be sent back to the bank account within 5-7
          days.
        </div>
      </div>
      <div className="order-failed-modal--cta">
        <Button
          className="button button-primary full-width large"
          onClick={onCancel}
        >
          Verify & Pay
        </Button>
      </div>
    </Modal>
  );
};

export default OrderFailedModal;
